import { ClerkUser } from "shared/types/user";
import { UserResource } from "@clerk/types";
import { Id } from "components/kanbanBoard/types";


export const getUserImageUrlById = (userId: string, users: any[]) => {
    const foundUser = users.find((user) => user.id === userId);
    return foundUser?.image_url || null;
};

// Primair e-mailadres van een Clerk-gebruiker. De backend levert snake_case
// (Clerk API), de Clerk SDK camelCase — beide vormen komen in de app voor.
export const getUserEmail = (user: any): string => {
    if (!user) return "";
    return (
        user.email_addresses?.[0]?.email_address ||
        user.emailAddresses?.[0]?.emailAddress ||
        ""
    );
};

export const getUserName = (userId: string, users: any[]) => {
    const foundUser = users.find((user) => user.id === userId);

    if (!foundUser) {
        return { name: "" };
    }

    const firstName = foundUser.first_name || "";
    const lastName = foundUser.last_name || "";
    const fullName = `${firstName} ${lastName}`.trim();

    // Niet elk account heeft een voor-/achternaam in Clerk staan. Val dan terug op
    // het e-mailadres i.p.v. een lege naam: call sites tonen anders een ruwe id.
    return { name: fullName || getUserEmail(foundUser) };
};


export const getUserImageUrl = (
    user: ClerkUser | UserResource | Id | null | undefined,
    users: any[]
) => {
    if (!user) return null;

    // If it's an object with image_url, it's either UserResource or ClerkUser
    if (typeof user === "object" && "image_url" in user) {
        return user.image_url;
    }

    if (typeof user === "object" && "imageUrl" in user) {
        return user.imageUrl;
    }

    // If it's an ID, find the corresponding user in the users array
    if (typeof user === "string") {
        const foundUser = users.find((u) => u.id === user);
        return foundUser?.image_url || null;
    }

    return null;
};
